import { createContext } from 'react';
import { Notifications } from './types';

export const NotificationsContext = createContext<Notifications>(
  {} as Notifications
);
NotificationsContext.displayName = 'Notifications';
